import moment from 'moment';
import { dateFormats, intervalOptions } from '~/utils';

export const intervals = {
  get custom() {
    return intervalOptions.custom;
  },

  get next_7_days() {
    return {
      key: 'next_7_days',
      label: '7 days',
      start: moment().format(dateFormats.isoDate),
      end: moment().add(6, 'days').format(dateFormats.isoDate),
      unit: 'custom',
    };
  },

  get next_30_days() {
    return {
      key: 'next_30_days',
      label: '30 days',
      start: moment().format(dateFormats.isoDate),
      end: moment().add(29, 'days').format(dateFormats.isoDate),
      unit: 'custom',
    };
  },

  get next_60_days() {
    return {
      key: 'next_60_days',
      label: '60 days',
      start: moment().format(dateFormats.isoDate),
      end: moment().add(59, 'days').format(dateFormats.isoDate),
      unit: 'custom',
    };
  },

  get next_90_days() {
    return {
      key: 'next_90_days',
      label: '90 days',
      start: moment().format(dateFormats.isoDate),
      end: moment().add(89, 'days').format(dateFormats.isoDate),
      unit: 'custom',
    };
  },

  get next_180_days() {
    return {
      key: 'next_180_days',
      label: '180 days',
      start: moment().format(dateFormats.isoDate),
      end: moment().add(179, 'days').format(dateFormats.isoDate),
      unit: 'custom',
    };
  },

  get next_365_days() {
    return {
      key: 'next_365_days',
      label: '365 days',
      start: moment().format(dateFormats.isoDate),
      end: moment().add(364, 'days').format(dateFormats.isoDate),
      unit: 'custom',
    };
  },

  get next_4_weeks() {
    return {
      key: 'next_4_weeks',
      label: '4 weeks',
      start: moment().startOf('isoWeek').format(dateFormats.isoDate),
      end: moment().add(3, 'weeks').endOf('isoWeek').format(dateFormats.isoDate),
      unit: 'week',
    };
  },

  get next_8_weeks() {
    return {
      key: 'next_8_weeks',
      label: '8 weeks',
      start: moment().startOf('isoWeek').format(dateFormats.isoDate),
      end: moment().add(7, 'weeks').endOf('isoWeek').format(dateFormats.isoDate),
      unit: 'week',
    };
  },

  get next_12_weeks() {
    return {
      key: 'next_12_weeks',
      label: '12 weeks',
      start: moment().startOf('isoWeek').format(dateFormats.isoDate),
      end: moment().add(11, 'weeks').endOf('isoWeek').format(dateFormats.isoDate),
      unit: 'week',
    };
  },

  get next_26_weeks() {
    return {
      key: 'next_26_weeks',
      label: '26 weeks',
      start: moment().startOf('isoWeek').format(dateFormats.isoDate),
      end: moment().add(25, 'weeks').endOf('isoWeek').format(dateFormats.isoDate),
      unit: 'week',
    };
  },

  get next_52_weeks() {
    return {
      key: 'next_52_weeks',
      label: '52 weeks',
      start: moment().startOf('isoWeek').format(dateFormats.isoDate),
      end: moment().add(51, 'weeks').endOf('isoWeek').format(dateFormats.isoDate),
      unit: 'week',
    };
  },

  get next_3_months() {
    return {
      key: 'next_3_months',
      label: '3 months',
      start: moment().startOf('month').format(dateFormats.isoDate),
      end: moment().add(2, 'months').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },

  get next_6_months() {
    return {
      key: 'next_6_months',
      label: '6 months',
      start: moment().startOf('month').format(dateFormats.isoDate),
      end: moment().add(5, 'months').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },

  get next_9_months() {
    return {
      key: 'next_9_months',
      label: '9 months',
      start: moment().startOf('month').format(dateFormats.isoDate),
      end: moment().add(8, 'months').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },

  get next_12_months() {
    return {
      key: 'next_12_months',
      label: '12 months',
      start: moment().startOf('month').format(dateFormats.isoDate),
      end: moment().add(11, 'months').endOf('month').format(dateFormats.isoDate),
      unit: 'month',
    };
  },
};

export const intervalsByScope = {
  get day() {
    return [
      intervals.custom,
      intervals.next_7_days,
      intervals.next_30_days,
      intervals.next_60_days,
      intervals.next_90_days,
      intervals.next_180_days,
      intervals.next_365_days,
    ];
  },

  get week() {
    return [
      intervals.custom,
      intervals.next_4_weeks,
      intervals.next_8_weeks,
      intervals.next_12_weeks,
      intervals.next_26_weeks,
      intervals.next_52_weeks,
    ];
  },

  get month() {
    return [
      intervals.custom,
      intervals.next_3_months,
      intervals.next_6_months,
      intervals.next_9_months,
      intervals.next_12_months,
    ];
  },

  get all() {
    return [
      intervals.custom,
      intervals.next_7_days,
      intervals.next_30_days,
      intervals.next_60_days,
      intervals.next_90_days,
      intervals.next_180_days,
      intervals.next_365_days,
      intervals.next_4_weeks,
      intervals.next_8_weeks,
      intervals.next_12_weeks,
      intervals.next_26_weeks,
      intervals.next_52_weeks,
      intervals.next_3_months,
      intervals.next_6_months,
      intervals.next_9_months,
      intervals.next_12_months,
    ];
  },
};
